import TabsPanel from './TabsPanel';

export * from './TabsPanel';
export default TabsPanel;
